import { render, staticRenderFns } from "./ProjectTasksPanel.vue?vue&type=template&id=5f516600&scoped=true&"
import script from "./ProjectTasksPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectTasksPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTasksPanel.vue?vue&type=style&index=0&id=5f516600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f516600",
  null
  
)

export default component.exports